'use client';
import { usePromoCode } from '@/hooks/use-promo-code';

export function PriceCallout() {
  const { pricing } = usePromoCode();
  const isDifferent = pricing.original !== pricing.discounted;

  return (
    <div className='pt-5'>
      {isDifferent ? (
        <span className='flex justify-center md:justify-start gap-2 text-2xl'>
          <span>Only</span>
          <span className='line-through text-primary-foreground/50'>${pricing.original}</span>
          <span>${pricing.discounted}</span>
        </span>
      ) : (
        <span className='text-2xl'>Only $200</span>
      )}

      <span className='text-lg'> per pet</span>
    </div>
  );
}
